import type { CustomFieldBasicSetting } from './CustomFieldBasicSetting';

class CustomFieldBasicSettingProvider {
  /**
   * contextで使うカスタムフィールド基本情報設定情報
   *
   * @param key カスタムフィールドを特定するためのキー
   */
  private constructor(
    readonly key: number,
    readonly displayName: string,
    readonly attribute: string,
    readonly length: number,
  ) {}

  static fromSetting(setting: CustomFieldBasicSetting) {
    return new CustomFieldBasicSettingProvider(
      setting.customFieldKey,
      setting.displayName,
      setting.attribute,
      Number(setting.codeDigits),
    );
  }

  static fromSettings(settings: CustomFieldBasicSetting[]) {
    return settings.filter((setting) => setting.isUsed).map(CustomFieldBasicSettingProvider.fromSetting);
  }
}

export { CustomFieldBasicSettingProvider };
